import React, { useState, useEffect } from "react";
import { Button } from "./Button";
import { Link } from "react-router-dom";
import "./Navbar.css";
import tmurd from "./tmurd.png";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            TMURD
            <img src={tmurd} alt="tmurd" width="50" height="50" />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link
                to="/TooRareStories"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Too Rare Stories
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/podcasts"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Podcasts
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/educationHub"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Education Hub
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/Posters" className="nav-links" onClick={closeMobileMenu}>
                Posters
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/Team"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Team
              </Link>
            </li>

            <li>
              <Link
                to="/ContactUs"
                className="nav-links-mobile"
                onClick={closeMobileMenu}
              >
                Contact Us
              </Link>
            </li>
          </ul>
          {button && <Button buttonStyle="btn--outline">Contact Us</Button>}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
